import React, { useEffect, useState } from "react";
import SelectHotels from "./components/SelectHotels";
import SelectCustomers from "./components/SelectCustomers";
import SelectRooms from "./components/SelectRooms";
import BookingInfo from "./components/BookingInfo";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
import { requestHotelBooking } from "../../../api/admin/hotel";
import DataLoader from "../../../components/admin/usable/DataLoader";
function formatDate(date) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Dhaka",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}
const AddHotelBooking = () => {
  const [HotelId, setHotelId] = useState("");
  const [CustomerId, setCustomerId] = useState("");
  const [SelectedHotel, setSelectedHotel] = useState(null);
  const [SelectedCustomer, setSelectedCustomer] = useState(null);
  const [SelectedRoom, setSelectedRoom] = useState(null);
  const [SelectedRooms, setSelectedRooms] = useState([]);
  const [RoomsData, setRoomsData] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const [CheckIn, setCheckIn] = useState(formatDate(today));
  const [CheckOut, setCheckOut] = useState(formatDate(tomorrow));
  const generateBookingId = () =>
    Math.random().toString(36).substring(2, 10).toUpperCase();
  const prefix = "DH-";
  const randomNumber = Math.floor(100000 + Math.random() * 900000); // 6-digit number
  const code = `${prefix}${randomNumber}`;
  const [FormData, setFormData] = useState({
    invoiceId: code,
    transactionId: generateBookingId(),
    invoiceFor: "Hotel",
    type: "Hotel",
    hotelId: "",
    checkIn: "",
    checkOut: "",
    totalAmount: 0,
    discountedAmount: 0,
    taxAmount: 0,
    paidAmount: 0,
    paymentNature: "Online",
    paymentStatus: "Unpaid",
    orderBy: "",
    primaryPhoneNumber: "",
    isAirporPickupNeed: 0,
    isExtraBedRequired: 0,
    isRoomOnHigherFloor: 0,
    isRoomDecorationRequired: 0,
    IsLargeBedRequired: 0,
    isTwinBedRequired: 0,
    isSmoking: 0,
    request: "",
    rooms: [],
    isAgreed: 0,
  });
  const nights =
    CheckIn && CheckOut
      ? (new Date(CheckOut) - new Date(CheckIn)) / (1000 * 60 * 60 * 24)
      : 0;
  useEffect(() => {
    if (HotelId) {
      setFormData((prev) => {
        return { ...prev, hotelId: HotelId };
      });
    }
    if (SelectedRooms) {
      setFormData((prev) => {
        return {
          ...prev,
          rooms: SelectedRooms,
        };
      });
    }
    if (SelectedCustomer) {
      setFormData((prev) => {
        return {
          ...prev,
          orderBy: SelectedCustomer.id,
          primaryPhoneNumber: SelectedCustomer.phoneNumber,
        };
      });
    }
    if (CheckIn && CheckOut) {
      setFormData((prev) => {
        return {
          ...prev,
          checkIn: CheckIn,
          checkOut: CheckOut,
        };
      });
    }
  }, [HotelId, SelectedRooms, SelectedCustomer, CheckIn, CheckOut]);
  useEffect(() => {
    if (SelectedRooms) {
      const roomsWithDiscount = SelectedRooms.map((room) => {
        const actualPrice = Number(room.actualPrice) || 0;
        const discount = Number(room.discount) || 0;

        const discountedPrice = actualPrice - (actualPrice * discount) / 100;

        return {
          ...room,
          discountedPrice,
        };
      });

      setFormData((prev) => ({
        ...prev,
        rooms: roomsWithDiscount,
      }));
    }
  }, [SelectedRooms]);
  const totalAmount = SelectedRooms.reduce((total, item) => {
    return total + item.actualPrice;
  }, 0);
  const discounted = SelectedRooms.reduce((total, item) => {
    const price = item.actualPrice || 0;
    const discount = item.discount || 0;

    const discountedPrice = price - (price * discount) / 100;

    return total + discountedPrice;
  }, 0);
  const totalTaxAmount = SelectedRooms.reduce((total, item) => {
    const price = item.actualPrice || 0;
    const discount = item.discount || 0;

    const discountedPrice = price - (price * discount) / 100;

    const taxAmount = (discountedPrice * (item.tax || 0)) / 100;

    return total + taxAmount;
  }, 0);

  const finalAmount =
    (discounted + totalTaxAmount) *
    (SelectedHotel?.advancePayment / 100) *
    nights;

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      totalAmount: totalAmount * nights,
      discountedAmount: discounted * nights,
      taxAmount: totalTaxAmount * nights,
      paidAmount: 0,
    }));
  }, [nights, totalAmount, discounted, totalTaxAmount, finalAmount]);
  const handleSubmit = () => {
    if (FormData.orderBy || FormData.totalTaxAmount || FormData.totalAmount) {
      requestHotelBooking(
        SelectedCustomer,
        SelectedHotel,
        FormData,
        setIsLoading,
      );
    }
  };

  return (
    <>
      {IsLoading && <DataLoader />}
      <div className="space-y-5">
        <div className="text-center pb-10">
          <p className="text-lg font-bold uppercase">Make A Booking Request</p>

          <small className="text-xs leading-tight">
            Remember this can make a request to the respective customer, <br />
            if customer pay the expected payment then it will be counted as
            booking for hotel
          </small>
        </div>
        <div className="space-y-3">
          <div className="grid grid-cols-3 gap-5">
            <div className="">
              <label htmlFor="" className="text-xs">
                Select Customers
              </label>
              <SelectCustomers
                CustomerId={CustomerId}
                setCustomerId={setCustomerId}
                setSelectedCustomer={setSelectedCustomer}
                SelectedCustomer={SelectedCustomer}
              />
            </div>
            <div className="">
              <label htmlFor="" className="text-xs">
                Select Hotel
              </label>
              <SelectHotels
                setHotelId={setHotelId}
                HotelId={HotelId}
                setSelectedHotel={setSelectedHotel}
                SelectedHotel={SelectedHotel}
              />
            </div>
            <div className="">
              <label htmlFor="" className="text-xs">
                Select Room
              </label>
              <SelectRooms
                HotelId={HotelId}
                SelectedRoom={SelectedRoom}
                setSelectedRoom={setSelectedRoom}
                setSelectedRooms={setSelectedRooms}
                setRoomsData={setRoomsData}
                CheckIn={CheckIn}
                CheckOut={CheckOut}
                code={code}
              />
            </div>
          </div>
          <div>
            <BookingInfo
              CheckIn={CheckIn}
              CheckOut={CheckOut}
              RoomsData={RoomsData}
              SelectedCustomer={SelectedCustomer}
              SelectedHotel={SelectedHotel}
              setCheckIn={setCheckIn}
              setCheckOut={setCheckOut}
              code={code}
              FormData={FormData}
              finalAmount={finalAmount}
            />
          </div>
          <div className="flex justify-center items-center gap-3">
            <AddButton
              onClick={handleSubmit}
              text={IsLoading ? "Processing" : "Send your request"}
            />
            <CancelButton text={"Cancel Request"} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddHotelBooking;
